import moment from "moment";
import { pointsConfig } from "../../pointsConfig";

export function pointRewardTableData(data) {
  const typeOptions = Object.values(pointsConfig.rewardCreation.rewardTypes);

  return [
    {
      elements: [
        {
          type: "text",
          value: data?.title,
        },
        {
          type: "text",
          value: data?.description,
        },
      ],
      value: "",
      width: "md:w-[45%]",
    },
    {
      elements: [
        {
          type: "text",
          value: (data?.pointsCost || 0).toLocaleString(),
        },
      ],
      value: "",
      width: "md:w-[10%]",
    },
    {
      elements: [
        {
          type: "text",
          value:
            typeOptions.find(
              (option) =>
                option.code === data?.type ||
                option.code === (data?.type ?? "").toLowerCase(),
            )?.label || "---",
        },
      ],
      value: "",
      width: "md:w-[10%]",
    },

    {
      elements: [
        {
          type: "toggle",
          value: { ...data, dataType: "reward" },
        },
      ],
      value: "",
      width: "md:w-[10%]",
    },
    {
      elements: [
        {
          type: "text",
          value: moment(data?.createdAt).format("YYYY/MM/DD"),
        },
        {
          type: "title",
          value: moment(data?.createdAt).format("hh:mm A"),
        },
      ],
      value: "",
      width: "md:w-[10%]",
    },
  ];
}
